export function initToc($) {
  // TOC position
  function positionToc() {
    var $toc = $(".single-toc_outer");
    if (!$toc.length) return;
    if ($(window).width() >= 1300) {
      $toc.css("left", "0");
    } else {
      $toc.css("left", "");
    }
  }
  positionToc();
  $(window).on("resize", positionToc);
  
  // TOC sticky follow — fixed within #main bounds
  (function () {
    var $toc = $(".single-toc_outer");
    if (!$toc.length) return;
  
    var $main = $("#main");
    var $header = $(".header");
    var fixedLeft = 0,
      stickyTop = 0,
      triggerAt = 0,
      tocW = 0;
  
    function measure() {
      if ($(window).width() < 1300) return;
      // Reset to natural absolute state so offset() is accurate
      $toc.css({ position: "absolute", top: "24px", width: "" });
      positionToc();
  
      var headerH = $header.outerHeight() || 0;
      stickyTop = headerH + 24;
      fixedLeft = $toc.offset().left;
      triggerAt = $toc.offset().top - stickyTop;
      tocW = $toc.outerWidth();
    }
  
    function update() {
      if ($(window).width() < 1300) {
        $toc.css({ position: "", top: "", width: "" });
        positionToc();
        return;
      }
  
      var scrollTop = $(window).scrollTop();
  
      if (scrollTop < triggerAt) {
        $toc.css({ position: "absolute", top: "24px", width: "" });
        positionToc();
        return;
      }
  
      // Clamp top so the TOC doesn't scroll past the bottom of #main
      var mainBotViewport = $main.offset().top + $main.outerHeight() - scrollTop;
      var tocH = $toc.outerHeight();
      var top = Math.min(stickyTop, mainBotViewport - tocH - 24);
  
      $toc.css({ position: "fixed", top: top + "px", left: fixedLeft + "px", width: tocW + "px" });
    }
  
    $(window).on("load", function () {
      measure();
      update();
    });
    $(window).on("scroll.toc", update);
    $(window).on("resize.toc", function () {
      measure();
      update();
    });
  
    measure();
    update();
  })();
  
  // TOC smooth scroll
  $(".single-toc_list a").on("click", function (e) {
    e.preventDefault();
    var targetId = $(this).attr("href");
    var $target = $(targetId);
    if ($target.length) {
      var headerHeight = $(".header").outerHeight() || 0;
      var targetPosition = $target.offset().top - headerHeight;
      $("html, body").animate(
        {
          scrollTop: targetPosition,
        },
        600,
      );
    }
  });
}
